import { v4 as uuidv4 } from 'uuid';

/**
 * @typedef {"int" | "si" | "object" | "date" | "array"} MapEditConditionObject
 */

/**
 * @typedef {object} ObjectsValue
 * @type {object}
 * @property {Object} id
 * @property {string} label
 */

/**
 * @typedef {object} StylesValue
 * @type {object}
 * @property {Object} background
 * @property {Object} icon
 * @property {Object} name
 * @property {Object} border
 */

/**
 * @typedef {object} MapSchemeStylesValue
 * @type {object}
 * @property {Object} cover
 */

/**
 * @typedef {object} ConfigValue
 * @type {object}
 * @property {Object} conditions
 * @property {Object} geodata
 * @property {Object} resultsDynamicGeodata
 */

/** @type {MapSchemeStylesValue} */
export class MapSchemeEditStyles {
  cover = {
    opacity: 20,
    color: '#ffffff',
    type: 'color'
  }

  constructor() {
    this.cover = {
      opacity: 20,
      color: '#ffffff',
      type: 'color'
    }
  }
}
/** @type {StylesValue} */
export class MapEditStyles {
  cover = {
    opacity: 20,
    color: '#328fe5',
    type: 'color'
  }
  background = {
    opacity: 20,
    color: '#328fe5',
    type: 'color'
  }
  icon = {
    borderColor: null,
    backgroundColor: null,
    size: 36,
    existence: 'none',
    shadow: 'none',
  }
  name = {
    fontSize: 12,
    color: '#000000',
    direction: 'horizontal',
    show: true
  }
  border = {
    line: 'solid',
    lineWidth: 1,
    color: '#328FE6',
    shadow: 'none',
  }
  unShow = false
  hasNotSnoska = false

  constructor() {
    this.cover = {
      opacity: 20,
      color: '#328fe5',
      type: 'color'
    }
    this.background = {
      opacity: 20,
      color: '#328fe5',
      type: 'color'
    }
    this.icon = {
      borderColor: '#328FE6',
      backgroundColor: 'white',
      size: 36,
      existence: 'none',
      shadow: 'none',
    }
    this.name = {
      fontSize: 12,
      color: '#000000',
      direction: 'horizontal',
      show: true
    }
    this.border = {
      line: 'solid',
      lineWidth: 1,
      color: '#328FE6',
      shadow: 'none',
    }
    this.unShow = false
    this.hasNotSnoska = false
  }
}
export class MapEditCondition {
  /** @type {ObjectsValue} */
  objects = []
  /** @type {MapEditStyles} */
  styles = {}
  uuid = ""
  geoType = 'all'

  constructor() {
    this.uuid = uuidv4()
    this.objects = []
    this.styles = {
      cover: {
        opacity: 20,
        color: '#328fe5',
        type: 'color'
      },
      background: {
        opacity: 20,
        color: '#328fe5',
        type: 'color'
      },
      icon: {
        borderColor: '#328FE6',
        backgroundColor: 'white',
        size: 36,
        existence: 'none',
        shadow: 'none',
      },
      name: {
        fontSize: 12,
        color: '#000000',
        direction: 'horizontal',
        show: true
      },
      border: {
        line: 'solid',
        lineWidth: 1,
        color: '#328FE6',
        shadow: 'none',
      },
      unShow: false,
      hasNotSnoska: false
    }
  }
}

